import { render } from "./ZfAvatar.vue?vue&type=template&id=61f5c9a2&scoped=true&ts=true"
import script from "./ZfAvatar.vue?vue&type=script&lang=ts"
export * from "./ZfAvatar.vue?vue&type=script&lang=ts"

import "./ZfAvatar.vue?vue&type=style&index=0&id=61f5c9a2&lang=less&scoped=true"
import "./ZfAvatar.vue?vue&type=style&index=1&id=61f5c9a2&lang=less"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.30_vue@3.2.37_webpack@5.105.4_@swc+core@1.15.18_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61f5c9a2"]])

export default __exports__